import { render, staticRenderFns } from "./ApdMutation.vue?vue&type=template&id=12b7120a&scoped=true&"
import script from "./ApdMutation.vue?vue&type=script&lang=js&"
export * from "./ApdMutation.vue?vue&type=script&lang=js&"
import style0 from "./ApdMutation.vue?vue&type=style&index=0&id=12b7120a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b7120a",
  null
  
)

export default component.exports